import React from 'react';
import ReactCardFlip from 'react-card-flip';

class CardFlipView extends React.Component {

  constructor() {
    super();
    this.state = {
      isFlipped: false
    };
    this.timeoutRefs = new Set();
  }

  componentWillUnmount() {
    this.timeoutRefs.forEach((timeoutRef) => {
      clearTimeout(timeoutRef);
    });
    this.timeoutRefs.clear();
  }

  flip() {
    if (this.props.onFlipStart) {
      this.props.onFlipStart();
    }
    this.setState({isFlipped: !this.state.isFlipped}, () => {
      const timeoutRef = setTimeout(() => {
        if (this.props.onFlipEnd) {
          this.props.onFlipEnd();
        }
      }, 350);
      this.timeoutRefs.add(timeoutRef);
    });
  }

  render() {
    return (
      <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection="vertical">
        {this.props.children}
      </ReactCardFlip>
    )
  }
}

export default CardFlipView;
